import React from "react";
import "./css/index.css";
import "./css/PixelImage.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./useStyles.js";
import ColorPanel from "./ColorPanel.js";

class ExtentionTabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
    };
  }

  handleTabChange = (newValue) => {
    this.setState({ value: newValue });
  };

  handleColorClick = (color, colorIndex) => {
    this.props.onHandleColorChange(color, colorIndex);
  };

  handleColorChange = (colorIndex, newColor) => {
    this.props.onHandleColorChange(newColor, colorIndex);
  };

  render() {
    const {
      colors,
      rows,
      pickerAnchorRef,
      descending,
      rightToLeft,
      flatKnitting,
      knittingInTheRound,
      onOrderChange,
      onDirectionChange,
      onKnittingInTheRoundChange,
    } = this.props;

    const { value } = this.state;

    return (
      <div className="extensions-ui">
        <ColorPanel
          colors={colors}
          rows={rows}
          activeTab={value}
          onTabChange={this.handleTabChange}
          onColorClick={this.handleColorClick}
          onColorChange={this.handleColorChange}
          pickerAnchorRef={pickerAnchorRef}
          descending={descending}
          rightToLeft={rightToLeft}
          flatKnitting={flatKnitting}
          knittingInTheRound={knittingInTheRound}
          onOrderChange={onOrderChange}
          onDirectionChange={onDirectionChange}
          onKnittingInTheRoundChange={onKnittingInTheRoundChange}
        />
      </div>
    );
  }
}

ExtentionTabs.propTypes = {
  classes: PropTypes.object,
  colors: PropTypes.array.isRequired,
  rows: PropTypes.array,
  onHandleColorChange: PropTypes.func.isRequired,
  onSortEnd: PropTypes.func,
  pickerAnchorRef: PropTypes.object,
  descending: PropTypes.bool,
  rightToLeft: PropTypes.bool,
  flatKnitting: PropTypes.bool,
  knittingInTheRound: PropTypes.bool,
  onOrderChange: PropTypes.func,
  onDirectionChange: PropTypes.func,
  onKnittingInTheRoundChange: PropTypes.func,
};

export default withStyles(styles)(ExtentionTabs);